import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { completeVisitAction } from '../../../redux/actions/visitActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';

const CompleteVisitModal = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit?.visit);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(completeVisitAction(vin, id));
    setLoading(false);
  };

  return (
    <Modal
      title={'Завершення візиту'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте завершити цей візит?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Завершити'} />}
    />
  );
};

export default CompleteVisitModal;
